import { styled } from 'styled-components';

import { Flexbox } from '@components/web/src/foundations/Flexbox/Flexbox';
import { COLORS } from '@components/web/src/styles';

export const ProductRateModalContainer = styled.div`
  padding: 16px 16px 32px;
  background-color: ${COLORS.base.white};
  border-radius: 16px;
`;

export const ContentWrapper = styled(Flexbox)`
  text-align: center;
`;

export const HeadingWrapper = styled(Flexbox)`
  text-align: center;
`;

export const ButtonWrapper = styled.div`
  margin-top: 16px;
`;
